<template>
  <div>
    <b-container class="view-container">
      <h4 v-if="!isAuthenticated">Loggar in...</h4>
      <p v-if="user.status === 401">
        Det verkar inte som att du har åtkomst till inloggning för "Stöd vid läkemedelshantering". Prata med din systemadministratör för att begära tillgång.
      </p>
      <div v-if="isAuthenticated" class="text-center">
        <h4>Du är inloggad!</h4>
        <router-link to="/">Gå till startsidan</router-link>
      </div>
    </b-container>
  </div>
</template>

<script>

import { getToken } from '../store/actions'

export default {
  name: 'GetToken',
  mounted () {
    getToken(this.$store)
  },
  computed: {
    isAuthenticated () {
      return this.$store.state.user.isAuthenticated
    },
    user () {
      return this.$store.state.user
    }
  },
  watch: {
    isAuthenticated: function (val) {
      if (val) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
  a {
    text-decoration: underline
  }
</style>
